var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoBam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.601 22.9999C11.0201 22.9999 7.43773 22.9999 3.85688 22.9999C2.03291 22.9999 1.00625 21.9845 1.00469 20.1758C1.00312 15.9295 1.00937 11.6832 1 7.43694C0.998444 6.31444 1.42596 5.43724 2.45419 4.95284C2.85986 4.76187 3.35135 4.68735 3.80695 4.67493C5.13007 4.63922 6.45319 4.66406 7.77787 4.66095C8.3895 4.66095 8.54241 4.55848 8.77177 3.99335C9.13063 3.10839 9.4895 2.22498 9.83276 1.33535C9.92326 1.10247 10.0262 1 10.304 1C13.1983 1.01242 16.0911 1.01087 18.9854 1.00155C19.2319 1.00155 19.352 1.07297 19.4394 1.30275C19.7764 2.1815 20.1353 3.05249 20.4848 3.92659C20.7454 4.57556 20.8702 4.66095 21.5879 4.66095C22.8986 4.66095 24.2092 4.6563 25.5198 4.66251C26.6339 4.66872 27.5264 5.09722 28.0132 6.12502C28.1895 6.49609 28.2644 6.94633 28.2659 7.36087C28.2831 11.6848 28.2831 16.0087 28.2737 20.3326C28.2706 21.9519 27.2065 22.9937 25.5807 22.9968C21.9218 23.003 18.263 22.9983 14.6025 22.9983L14.601 22.9999Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6535 7.77344C17.5388 7.7779 19.8294 10.1255 19.8163 13.0648C19.8031 15.9431 17.492 18.2832 14.6491 18.2951C11.7931 18.307 9.45711 15.9223 9.46879 13.0038C9.48048 10.0883 11.7814 7.76898 14.6535 7.77344V7.77344Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoBam);
export default __webpack_public_path__ + "static/media/photo-bam.1d37f9b3a821c7709cebcfcde0231124.svg";
export { ForwardRef as ReactComponent };